import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-715fc91a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClickCapture"]
const _hoisted_2 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "checker unchecked"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!
  const _component_item_file = _resolveComponent("item-file")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_item_video = _resolveComponent("item-video")!
  const _component_item_folder = _resolveComponent("item-folder")!
  const _component_item_case = _resolveComponent("item-case")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["item-wrapper", [_ctx.row ? 'item-wrapper-row' : '', _ctx.column ? 'column' : '']])
    }, [
      (!_ctx.skeleton)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonsAmount, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([_ctx.row ? 'item-row' : '', _ctx.column ? 'column-item' : 'item']),
                key: n
              }, [
                _createVNode(_component_app_skeleton_media, { columnView: _ctx.column }, null, 8, ["columnView"])
              ], 2))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mixedList, (mixed) => {
              return (_openBlock(), _createElementBlock("div", {
                key: mixed.id,
                class: _normalizeClass([_ctx.row ? 'item-row' : '', _ctx.column ? 'column-item' : 'item']),
                onClickCapture: ($event: any) => (_ctx.select($event, mixed))
              }, [
                (mixed.type === _ctx.MIXED_DATA_TYPE.FILE)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (mixed.file!.type === _ctx.MEDIA_TYPES.FILES)
                        ? (_openBlock(), _createBlock(_component_item_file, {
                            key: 0,
                            file: mixed.file!,
                            hideDelete: _ctx.hideDelete,
                            columnView: _ctx.column,
                            preventOpen: _ctx.selector,
                            "is-mixed": ""
                          }, null, 8, ["file", "hideDelete", "columnView", "preventOpen"]))
                        : _createCommentVNode("", true),
                      (mixed.file!.type === _ctx.MEDIA_TYPES.PHOTO)
                        ? (_openBlock(), _createBlock(_component_item_photo, {
                            key: 1,
                            photo: mixed.file!,
                            hideDelete: _ctx.hideDelete,
                            columnView: _ctx.column,
                            preventOpen: _ctx.selector,
                            "data-test": "123",
                            "is-mixed": ""
                          }, null, 8, ["photo", "hideDelete", "columnView", "preventOpen"]))
                        : _createCommentVNode("", true),
                      (mixed.file!.type === _ctx.MEDIA_TYPES.VIDEO)
                        ? (_openBlock(), _createBlock(_component_item_video, {
                            key: 2,
                            file: mixed.file!,
                            hideDelete: _ctx.hideDelete,
                            columnView: _ctx.column,
                            preventOpen: _ctx.selector,
                            thumbnail: "",
                            "is-mixed": ""
                          }, null, 8, ["file", "hideDelete", "columnView", "preventOpen"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (mixed.type === _ctx.MIXED_DATA_TYPE.FOLDER)
                    ? (_openBlock(), _createBlock(_component_item_folder, {
                        key: 1,
                        folder: mixed.folder!,
                        hideDelete: _ctx.hideDelete,
                        columnView: _ctx.column,
                        preventOpen: _ctx.selector,
                        onOpenFolder: ($event: any) => (_ctx.openFolder(mixed)),
                        onFolderDeleted: _ctx.removeFromSearch
                      }, null, 8, ["folder", "hideDelete", "columnView", "preventOpen", "onOpenFolder", "onFolderDeleted"]))
                    : (mixed.type === _ctx.MIXED_DATA_TYPE.CASE)
                      ? (_openBlock(), _createBlock(_component_item_case, {
                          key: 2,
                          iCase: mixed.case!,
                          columnView: _ctx.column,
                          onOpenCase: ($event: any) => (_ctx.openCase(mixed.case!))
                        }, null, 8, ["iCase", "columnView", "onOpenCase"]))
                      : _createCommentVNode("", true),
                (_ctx.selector && !_ctx.systemFolders.includes(mixed.folder?.id))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["selector", { 'selector-column': _ctx.column }])
                    }, [
                      (mixed.selected)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_1))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.skeleton || _ctx.loading)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.folderFileAmount, (n) => {
            return (_openBlock(), _createElementBlock("div", {
              key: n,
              class: _normalizeClass([_ctx.row ? 'item-row' : '', _ctx.column ? 'column-item' : 'item'])
            }, [
              _createVNode(_component_app_skeleton_media, { columnView: _ctx.column }, null, 8, ["columnView"])
            ], 2))
          }), 128))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}